
import Model from "@/models/yunMobile";
import Icon from 'vux/src/components/icon/index.vue'

import { mapActions } from "vuex";
import loadScript from "@/config/loadScript";
export default {
components: {
Icon
},
data() {
return {
formData: {
tel: "",
parkNo: this.$route.params.parkNo,
passNo: this.$route.params.passid
},
appid: "",
parkId: ""
};
},
methods: {
...mapActions("yunMobile", {
sendPhone: "setCarinBranchAction"
}),
submit() {
if (!/^1[3-9]\d{9}$/.test(this.formData.tel)) {
this.$layer.msg("请输入正确的手机号码");
return;
}
sessionStorage.setItem("isNoCar", 1);
if (this.$route.query.pay == 1) {
let _data = {
passNo: this.formData.passNo,
parkNo: this.formData.parkNo,
carNo: this.formData.tel.replace(/\s+/g, "")
};
this.sendPhone(_data).then(() => {
this.$router.push({ path: `/mobile/yunMobile/confirmPay/2` });
});
} else {
this.openPark();
}
},
async openPark() {
let { data } = await Model.openParkByPhone(this.formData);
this.formData.tel = "";
}
},
created() {
let tel = localStorage.getItem("carNo");
if (!isNaN(tel)) {
this.formData.tel = tel;
}
},

mounted() {
Model.getAdvertising({ parkNo: this.$route.params.parkNo, number: 1 }).then(
res => {
loadScript("http://sdk.anbokeji.net/adv/index.js", () => {
const st = document.querySelector("#anbo-ad-st");
if (st) {
document.body.removeChild(st);
}
const script = document.createElement("script");
script.type = "text/javascript";
script.id = "anbo-ad-st";
script.innerHTML = `__anbo_adv_sdk__.init({appid: "${
res.data.appid
}", adPosId: 4,parkId: "${res.data.parkId}"})`;
document.body.append(script);
document.querySelector(".advwrap").innerHTML =
"<anboadv @show='advShow'></anboadv>";
window.advShow = function(res) {

};
});
}
);
}
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/enterPhone.vue